import * as React from "react";
import clsx from "clsx";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { Image } from "../../image/image.mjs";
const FeatureListItem = (props) => {
  const { className, icon, grid, children } = props;
  const renderIcon = () => {
    if (typeof icon === "string") {
      return /* @__PURE__ */ React.createElement(Icon, { className: "feature-list__item-icon", modifiers: icon, align: "none" });
    }
    return /* @__PURE__ */ React.createElement(Image, { ...icon, className: "feature-list__item-image" });
  };
  return /* @__PURE__ */ React.createElement("li", { className: clsx("feature-list__item", className) }, /* @__PURE__ */ React.createElement("div", { className: "feature-list__item-inner" }, /* @__PURE__ */ React.createElement(Grid, { verticalGutter: "smedium", wrap: ["md"], noWrap: ["xs"], align: ["middle-xs"], ...grid }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"], className: "feature-list__item-icon-col" }, renderIcon()), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, /* @__PURE__ */ React.createElement("div", { className: "feature-list__item-content" }, children)))));
};
export {
  FeatureListItem
};
